import PropTypes from 'prop-types';
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import TableContainer from '../../components/Common/DataTableContainer';

const BookingsTable = ({ bookings }) => {
    const navigate = useNavigate();

    const columns = useMemo(
        () => [
          {
            header: 'Customer',
            accessorKey: 'customer',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Vehicle',
            accessorKey: 'vehicle',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Payment Status',
            accessorKey: 'paymentStatus',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Booking Status',
            accessorKey: 'bookingStatus',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Amount',
            accessorKey: 'amount',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Action',
            id: 'action',
            cell: ({ row }) => {
              const bookingId = row.original?.bookingId;
              return (
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => navigate(`/bookings/${bookingId}`)}
                >
                  <i className="mdi mdi-eye"></i> View
                </button>
              );
            }
          }
        ],
        []
      );

    const totalRecords = bookings?.length ?? 0;
    
    const transformedData = useMemo(() => {
      return bookings?.map(item => {
          return {
              bookingId: item.id,
              customer: item.customer || "N/A",
              vehicle: item.vehicle || "-",
              paymentStatus: item.payment_status || "N/A",
              bookingStatus: item.status == 1 ? 'Pending' : (item.status == 2 ? 'Ongoing' : (item.status == 3 ? 'Arrived' : (item.status == 4 ? 'Start' : (item.status == 5 ? 'Complete' : (item.status == 6 ? 'Cancel' : (item.status == 7 ? 'Expired' : (item.status == 8 ? 'Schedule' : (item.status == 9 ? 'Schedule Accept' : '-')))))))) || "N/A",
              amount: item.total_amount || "0.00",
          };
      });
    }, [bookings]);

    return (
    <>
    {!bookings ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}
      </>
  );
};

BookingsTable.propTypes = {
  bookings: PropTypes.any
};

export default BookingsTable;